/* eslint-disable no-console */
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { PersistGate } from 'redux-persist/integration/react';

import themes from './styles/themes';

import App from './components/App';
import Loading from './components/LoadingOverlay';
import { SidebarProvider } from './components/Sidebar/SidebarContext';
import UpdateNotification from './components/UpdateNotification';
import { PWAProvider } from './hooks/usePWA';
import './i18n';
import { loadConfig } from './settings';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { persitor, store } from './store';

// Root container for update notification
let updateNotificationContainer: HTMLDivElement | null = null;

const showUpdateNotification = (registration: ServiceWorkerRegistration) => {
  // Create container if it doesn't exist
  if (!updateNotificationContainer) {
    updateNotificationContainer = document.createElement('div');
    updateNotificationContainer.id = 'pwa-update-notification';
    document.body.appendChild(updateNotificationContainer);
  }

  // Render the update notification
  ReactDOM.render(
    <ThemeProvider theme={themes.LIGHT}>
      <UpdateNotification registration={registration} />
    </ThemeProvider>,
    updateNotificationContainer
  );
};

loadConfig().then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <Suspense fallback={<Loading loading />}>
        <PersistGate loading={null} persistor={persitor}>
          <Provider store={store}>
            <PWAProvider>
              <SidebarProvider>
                <App />
              </SidebarProvider>
            </PWAProvider>
          </Provider>
        </PersistGate>
      </Suspense>
    </React.StrictMode>,
    document.getElementById('root'),
  );

  // Register service worker for PWA functionality
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      console.log('Nova versão do PWA disponível!');
      showUpdateNotification(registration);
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onSuccess: (_registration) => {
      console.log('PWA instalado com sucesso! O app agora funciona offline.');
    },
  });
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
